export const CREATE_BEATZ = 'BEATZ/CREATE';
export const LOAD_BEATZ = 'BEATZ/LOAD';
export const LOADING_STATUS = 'BEATZ/LOADING_STATUS';
